import { styled } from '@ltvco/refresh-lib/theme';

import { ReportColumnContainer } from 'components/DeepSearch/components/components';

export const MonitoringColumnContainer = styled(ReportColumnContainer, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<{ isMobile: boolean }>(({ isMobile }) => ({
  minWidth: 0,
  flexShrink: 0,
  ...(isMobile
    ? {
        flexGrow: 1,
        flexBasis: '100%',
        animation: 'fadeInScale 0.4s ease-out',
        '@keyframes fadeInScale': {
          '0%': { transform: 'scale(0.95)', opacity: 0 },
          '100%': { transform: 'scale(1)', opacity: 1 },
        },
      }
    : {
        animation: 'slideInFromRight 0.5s ease-out',
        '@keyframes slideInFromRight': {
          '0%': { transform: 'translateX(100%)', opacity: 0 },
          '100%': { transform: 'translateX(0)', opacity: 1 },
        },
      }),
}));
